// extracted by mini-css-extract-plugin
module.exports = {"screen":"AuditLayout_screen__3wNZs","header":"AuditLayout_header__Wn-97"};